__turbopack_context__.v({
  "logoLink": "mobile-navbar-module-scss-module__0G-Y4q__logoLink",
  "membershipLink": "mobile-navbar-module-scss-module__0G-Y4q__membershipLink",
  "mobileMenuOpen": "mobile-navbar-module-scss-module__0G-Y4q__mobileMenuOpen",
  "mobileNavBtns": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavBtns",
  "mobileNavContainer": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavContainer",
  "mobileNavMenu": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavMenu",
  "mobileNavMenuButtons": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavMenuButtons",
  "mobileNavMenuContainer": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavMenuContainer",
  "mobileNavMenuFooter": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavMenuFooter",
  "mobileNavMenuGroupLinks": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavMenuGroupLinks",
  "mobileNavbar": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavbar",
  "mobileNavbarContent": "mobile-navbar-module-scss-module__0G-Y4q__mobileNavbarContent",
  "navBtn": "mobile-navbar-module-scss-module__0G-Y4q__navBtn",
  "navScrim": "mobile-navbar-module-scss-module__0G-Y4q__navScrim",
  "overlay": "mobile-navbar-module-scss-module__0G-Y4q__overlay",
  "scrolled": "mobile-navbar-module-scss-module__0G-Y4q__scrolled",
  "shown": "mobile-navbar-module-scss-module__0G-Y4q__shown",
  "sticky": "mobile-navbar-module-scss-module__0G-Y4q__sticky",
  "ticketLink": "mobile-navbar-module-scss-module__0G-Y4q__ticketLink",
  "transitionsSuspended": "mobile-navbar-module-scss-module__0G-Y4q__transitionsSuspended",
});
